import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";

import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import {
  initCreateRateAdminAdvanceRateScreen,
  createRateAdminAdvanceRate,
  editRateAdminAdvanceRate,
  fetchRateAdminAdvanceRateById,
  searchAdvanceRate,
  updateAdvanceRate,
} from "../../../../redux/actions/RateAdmin/rateadminAdvanceRate";
import {
  fetchLocationDD
} from "../../../../redux/actions/location";
import {
  fetchRateAdminRateCodeDD
} from "../../../../redux/actions/RateAdmin/rateadminRateCode";
import {
  fetchVehicleCategoryDD
} from "../../../../redux/actions/vehicles/vehicleCategory";
import {
  fetchRateAdminNetworkDD,
  fetchRateAdminRateOptionsDD,
  fetchVehicleCategoryByLocation,
  fetchRevenuePreview,
} from "../../../../redux/actions/RateAdmin/rateadminRates";
import CreateRateAdminAdvanceRateComponent from "../../../../component/RateAdmin/RateAdminAdvanceRate/CreateRateAdminAdvanceRate";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

const CreateRateAdminAdvanceRateContainer = (props) => {
  const {
    isEdit,
    isView,
    isUpdate,
    isCopy,
    initCreateRateAdminAdvanceRateScreen,
    createRateAdminAdvanceRate,
    editRateAdminAdvanceRate,
    updateAdvanceRate,
    fetchRateAdminAdvanceRateById,
    searchAdvanceRate,
    fetchLocationDD,
    fetchRateAdminRateCodeDD,
    fetchVehicleCategoryDD,
    fetchRateAdminNetworkDD,
    fetchRateAdminRateOptionsDD,
    fetchCategoryByLocation,
    fetchRevenuePreview,
    isLoading,
    isRateAdminAdvanceRateCreateSuccess,
    isRateAdminAdvanceRateCreateError,
    isRateAdminAdvanceRateEditSuccess,
    isRateAdminAdvanceRateEditError,
    isRateAdminAdvanceRateDetailSuccess,
    isRateAdminAdvanceRateDetailError,
    isUpdateAdvanceRateSuccess,
    isUpdateAdvanceRateError,
    formFieldValueMap,
    locationDD,
    RateCodeDD,
    vehicleCategoryDD,
    RateOptionsDD,
    RateNetworkDD,
    updateData,
    searchData,
    isSearchLoading,
    isSearchSuccess,
    isSearchError,
    locationCategoryDD,
    isLocationCategoryDDLoading,
    revenuePreviewData,
    isRevenuePreviewSuccess,
  } = props;

  const { id } = useParams();
  const screenPermissions = useMemo(() => {
    try {
      const menuAccess = JSON.parse(localStorage.getItem("menuAccess"));
      return menuAccess?.advanceRateMenu || {};
    } catch {
      return {};
    }
  }, []);

  const callAPIasync = async () => {
    initCreateRateAdminAdvanceRateScreen();
    await fetchRateAdminNetworkDD();
    await fetchRateAdminRateOptionsDD();
    await fetchLocationDD();
    await fetchRateAdminRateCodeDD();
    await fetchVehicleCategoryDD();
    if (isEdit && !isUpdate) {
      await fetchRateAdminAdvanceRateById({ id });
    }
  };

  useEffect(() => {
    callAPIasync();
    // Reset success flags on unmount so they don't replay on remount
    return () => { initCreateRateAdminAdvanceRateScreen(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, isUpdate]);

  const createRateAdminAdvanceRateProps = {
    createRateAdminAdvanceRate,
    initCreateRateAdminAdvanceRateScreen,
    editRateAdminAdvanceRate,
    updateAdvanceRate,
    searchAdvanceRate,
    isLoading,
    isEdit,
    isUpdate,
    isCopy,
    isRateAdminAdvanceRateDetailSuccess,
    isRateAdminAdvanceRateCreateSuccess,
    isRateAdminAdvanceRateEditSuccess,
    isRateAdminAdvanceRateEditError,
    isUpdateAdvanceRateSuccess,
    isUpdateAdvanceRateError,
    formFieldValueMap,
    locationDD,
    RateCodeDD,
    vehicleCategoryDD,
    RateOptionsDD,
    RateNetworkDD,
    updateData,
    searchData,
    isSearchLoading,
    isSearchSuccess,
    isSearchError,
    fetchCategoryByLocation,
    locationCategoryDD,
    isLocationCategoryDDLoading,
    screenPermissions,
    fetchRevenuePreview,
    revenuePreviewData,
    isRevenuePreviewSuccess,
  };

  const getToastProps = () => {
    if (isRateAdminAdvanceRateCreateSuccess || isRateAdminAdvanceRateEditSuccess || isUpdateAdvanceRateSuccess) {
      const toastTitle = isUpdate
        ? "Advance Rate Updated Successfully"
        : isEdit
          ? "Advance Rate Updated Successfully"
          : "Advance Rate Created Successfully";
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle,
        shouldShowToast: true,
      };
    }

    if (
      isRateAdminAdvanceRateCreateError ||
      isRateAdminAdvanceRateDetailError ||
      isRateAdminAdvanceRateEditError ||
      isUpdateAdvanceRateError
    ) {
      let toastTitle = "Error while Creating Advance Rate";
      if (isRateAdminAdvanceRateEditError || isUpdateAdvanceRateError) {
        toastTitle = "Error while updating Advance Rate";
      } else if (isRateAdminAdvanceRateDetailError) {
        toastTitle =
          "Error while performing operation. Please refresh your browser";
      }

      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <EzToast {...getToastProps()} />
      <CreateRateAdminAdvanceRateComponent {...createRateAdminAdvanceRateProps} />
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: selectFromRateAdminAdvanceRateReducer(state, "isLoading"),
    isRateAdminAdvanceRateCreateSuccess: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateCreateSuccess"
    ),
    isRateAdminAdvanceRateCreateError: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateCreateError"
    ),
    isRateAdminAdvanceRateDetailSuccess: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateDetailSuccess"
    ),
    isRateAdminAdvanceRateDetailError: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateDetailError"
    ),
    isRateAdminAdvanceRateEditSuccess: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateEditSuccess"
    ),
    isRateAdminAdvanceRateEditError: selectFromRateAdminAdvanceRateReducer(
      state,
      "isRateAdminAdvanceRateEditError"
    ),
    formFieldValueMap: selectFromRateAdminAdvanceRateReducer(state, "formFieldValueMap"),
    updateData: selectFromRateAdminAdvanceRateReducer(state, "updateData"),
    searchData: selectFromRateAdminAdvanceRateReducer(state, "searchData"),
    isSearchLoading: selectFromRateAdminAdvanceRateReducer(state, "isSearchLoading"),
    isSearchSuccess: selectFromRateAdminAdvanceRateReducer(state, "isSearchSuccess"),
    isSearchError: selectFromRateAdminAdvanceRateReducer(state, "isSearchError"),
    isUpdateAdvanceRateSuccess: selectFromRateAdminAdvanceRateReducer(state, "isUpdateAdvanceRateSuccess"),
    isUpdateAdvanceRateError: selectFromRateAdminAdvanceRateReducer(state, "isUpdateAdvanceRateError"),
    vehicleCategoryDD: selectFromVehicleCategoryReducer(
      state,
      "vehicleCategoryDD"
    ),
    locationDD: selectFromLocationReducer(
      state,
      "locationDD"
    ),
    RateCodeDD: selectFromRateCodeReducer(
      state,
      "RateCodeDD"
    ),
    RateNetworkDD: selectFromRateAdminRatesReducer(
      state,
      "RateNetworkDD"
    ),
    RateOptionsDD: selectFromRateAdminRatesReducer(
      state,
      "RateOptionsDD"
    ),
    locationCategoryDD: selectFromRateAdminRatesReducer(
      state,
      "vehicleCategoryByLocationDD"
    ),
    isLocationCategoryDDLoading: selectFromRateAdminRatesReducer(
      state,
      "isLoading"
    ),
    revenuePreviewData: selectFromRateAdminRatesReducer(
      state,
      "revenuePreviewData"
    ),
    isRevenuePreviewSuccess: selectFromRateAdminRatesReducer(
      state,
      "isRevenuePreviewSuccess"
    ),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initCreateRateAdminAdvanceRateScreen: () => dispatch(initCreateRateAdminAdvanceRateScreen()),
    createRateAdminAdvanceRate: (payload) => dispatch(createRateAdminAdvanceRate(payload)),
    editRateAdminAdvanceRate: (payload) => dispatch(editRateAdminAdvanceRate(payload)),
    updateAdvanceRate: (payload) => dispatch(updateAdvanceRate(payload)),
    fetchVehicleCategoryDD: (payload) => dispatch(fetchVehicleCategoryDD(payload)),
    fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
    fetchRateAdminRateCodeDD: (payload) => dispatch(fetchRateAdminRateCodeDD(payload)),
    fetchRateAdminNetworkDD: (payload) => dispatch(fetchRateAdminNetworkDD(payload)),
    fetchRateAdminRateOptionsDD: (payload) => dispatch(fetchRateAdminRateOptionsDD(payload)),
    fetchRateAdminAdvanceRateById: (payload) => dispatch(fetchRateAdminAdvanceRateById(payload)),
    searchAdvanceRate: (payload) => dispatch(searchAdvanceRate(payload)),
    fetchCategoryByLocation: (payload) => dispatch(fetchVehicleCategoryByLocation(payload)),
    fetchRevenuePreview: (payload) => dispatch(fetchRevenuePreview(payload)),
  };
};

const selectFromRateAdminAdvanceRateReducer = (state, path) => {
  return selectRateAdminAdvanceRateReducer(state)[path];
};

const selectRateAdminAdvanceRateReducer = ({ rateadminAdvanceRateReducer }) => {
  return rateadminAdvanceRateReducer;
};

//For Network Rate and RateOptions
const selectFromRateAdminRatesReducer = (state, path) => {
  return selectRateAdminRatesReducer(state)[path];
};

const selectRateAdminRatesReducer = ({ rateadminRatesReducer }) => {
  return rateadminRatesReducer;
};

//Category
const selectFromVehicleCategoryReducer = (state, path) => {
  return selectVehicleCategoryReducer(state)[path];
};
const selectVehicleCategoryReducer = ({ vehicleCategoryReducer }) => {
  return vehicleCategoryReducer;
};

//Location
const selectFromLocationReducer = (state, path) => {
  return selectLocationReducer(state)[path];
};
const selectLocationReducer = ({ locationReducer }) => {
  return locationReducer;
};

//RateCode
const selectFromRateCodeReducer = (state, path) => {
  return selectRateCodeReducer(state)[path];
};
const selectRateCodeReducer = ({ rateadminRateCodeReducer }) => {
  return rateadminRateCodeReducer;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateRateAdminAdvanceRateContainer);
